import React, { ReactNode } from "react";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import MobileFooterSticky from "./(components)/MobileFooterSticky";
import { imageGallery as listingStayImageGallery } from "./listing-stay-detail/constants"


const DetailPagetLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const thisPathname = useLocation().pathname;
  const [searchParams] = useSearchParams();
  const modal = searchParams?.get("modal");

  // const handleCloseModalImageGallery = () => {
  //   let params = new URLSearchParams(document.location.search);
  //   params.delete("modal");
  //   navigate(`${thisPathname}/?${params.toString()}`);
  // };
    const handleCloseModalImageGallery = () => {      
    const params = new URLSearchParams(window.location.search);
    if (params.has("modal")) {
      params.delete("modal");
      const newQueryString = params.toString();
      const newUrl = `${window.location.pathname}?${newQueryString}`;
      window.history.replaceState({}, "", newUrl);
      navigate(newUrl);
    } else {
    }
    
  };
    const getImageGalleryListing = () => {
    if (thisPathname?.includes("/detail")) {
      return listingStayImageGallery;
    }
  };
  

  return (
    <div className="ListingDetailPage w-full">
      <ListingImageGallery
        isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"}
        onClose={handleCloseModalImageGallery}
        images={getImageGalleryListing()}

      />

      <div className="container ListingDetailPage__content">{children}</div>

    </div>
  );
};

export default DetailPagetLayout;
